/**
 * Free-usage hours: a promo code can grant a window in which Symphony charges nothing. The BFF reports
 * the window's end as `freeUsageUntil` on GetCreditsOverview (mapped to `CreditAccount.freeUsageUntilIso`).
 *
 * While the window is open, no credits surface may tell the user they are low, out, or at the daily
 * limit — none of those is true while nothing is charged. Pure, so the rule is testable without React.
 */

/** Whether the free-usage window is open at `now`. Absent or unparseable reads as closed. */
export function isFreeUsageActive(freeUsageUntilIso: string | null | undefined, now: number): boolean {
  if (!freeUsageUntilIso) return false;
  const until = new Date(freeUsageUntilIso).getTime();
  return Number.isFinite(until) && until > now;
}

/** Milliseconds until the window closes, or null when it is not open. Clamped to what `setTimeout` holds. */
export function freeUsageEndsInMs(freeUsageUntilIso: string | null | undefined, now: number): number | null {
  if (!isFreeUsageActive(freeUsageUntilIso, now)) return null;
  return Math.min(new Date(freeUsageUntilIso as string).getTime() - now, 2_147_483_647);
}

/** "Oct 14, 3:00 PM" in the reader's locale — a date AND a time, because the window is measured in hours. */
export function formatFreeUntil(freeUsageUntilIso: string, locale?: string): string {
  return new Date(freeUsageUntilIso).toLocaleString(locale, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
